import React from 'react';
import PropTypes from 'prop-types';
import {Badge, Card, CardBody, CardText} from "reactstrap5";
import {createIntl, createIntlCache, FormattedMessage} from "react-intl";
import Config from "../../utils/config";
import {getCurrentTranslation} from "../../utils/translations";
import RecommendationsOffcanvas from "../../../../general/react/Recommendation/RecommendationsOffcanvas";
import classnames from "classnames";
import VikyAnimation from "../../../../general/react/VikyAnimation";

class RecommendationsLabel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openOffcanvas: false,
        }

        this.showOffcanvas = () => {
            this.setState({openOffcanvas: true});
            document.querySelectorAll(".activity").forEach((el) => {
                el.classList.add("show-offcanvas");
            });
        }

        this.hideOffcanvas = () => {
            this.setState({openOffcanvas: false});
            document.querySelectorAll(".activity").forEach((el) => {
                el.classList.remove("show-offcanvas");
            });
        }
    }

    render() {
        const {recommendationActivities, colourTheme, activityDetail} = this.props;

        return (
            <>
                <Badge color={'danger'}
                       className={classnames('position-absolute top-0 start-50 translate-middle badge rounded-pill', {'d-xl-none': !activityDetail})}>
                    {recommendationActivities.length}
                </Badge>
                <a className="filter__label" href="javascript:;"
                   onClick={this.showOffcanvas}>
                    {!activityDetail && <VikyAnimation />}
                    <FormattedMessage defaultMessage='Viky doporučuje'/>
                    {activityDetail && <div className="big-animation">
                        <VikyAnimation />
                    </div>}
                </a>
                {this.state.openOffcanvas &&
                    <RecommendationsOffcanvas recommendationActivities={recommendationActivities}
                                              activityDetail={activityDetail} colourTheme={colourTheme}
                                              close={this.hideOffcanvas}/>}
            </>
        );
    }
}

RecommendationsLabel.propTypes = {
    recommendationActivities: PropTypes.array.isRequired,
    colourTheme: PropTypes.string,
    activityDetail: PropTypes.bool,
};

export default RecommendationsLabel;